module.exports = __webpack_public_path__ + "media/images/lp_consultation/access-icon02-95d7734cf8340e7a022055497896908b.png";